"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNPCIndicatorImagePath = void 0;
const NPC_1 = require("../classes/NPC");
const QuestState_1 = require("../types/QuestState");
const definables_1 = require("definables");
const getQuestGiverQuests_1 = require("./getQuestGiverQuests");
const getQuestPartyState_1 = require("./getQuestPartyState");
const getNPCIndicatorImagePath = (npcID) => {
    const npc = (0, definables_1.getDefinable)(NPC_1.NPC, npcID);
    if (npc.hasEncounterID()) {
        return "indicators/boss";
    }
    if (npc.hasInnCost()) {
        return "indicators/inn";
    }
    if (npc.hasShopID()) {
        return npc.shop.indicatorImagePath;
    }
    if (npc.hasQuestGiver()) {
        const questStates = (0, getQuestGiverQuests_1.getQuestGiverQuests)(npc.id).map((questGiverQuest) => (0, getQuestPartyState_1.getQuestPartyState)(questGiverQuest.questID));
        if (questStates.includes(QuestState_1.QuestState.TurnIn)) {
            return "indicators/quest/turn-in";
        }
        if (questStates.includes(QuestState_1.QuestState.Accept)) {
            return "indicators/quest/accept";
        }
        if (questStates.includes(QuestState_1.QuestState.InProgress)) {
            return "indicators/quest/in-progress";
        }
    }
    if (npc.hasDialogue() || npc.hasQuestGiver()) {
        return "indicators/dialogue";
    }
    throw new Error("No indicator image path found for NPC.");
};
exports.getNPCIndicatorImagePath = getNPCIndicatorImagePath;
